import moment from 'moment';

export const jrSem = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export function formatCodeFace(code) {
  return code.split(',')[0];
}

export function formatDate(date) {
  if (!date) return null;
  return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
}

export function formatDateExplicite(date) {
  return moment(date, 'DD/MM/YYYY').locale('fr').format('dddd Do MMMM YYYY');
}

export function formatDuree(duree) {
  if (duree === 1) {
    return duree + ' semaine';
  }
  if (duree > 1) {
    return duree + ' semaines';
  }
  return 'Non renseigné';
}

export function formatDureeNum(type, quantite) {
  if (type === 100 || type === 200) {
    if (quantite === 1) {
      return quantite + ' jour';
    }
    return quantite + ' jours';
  }
  if (type === 101 || type === 201) {
    if (quantite === 1) {
      return quantite + ' semaine';
    }
    return quantite + ' semaines';
  }
  if (type === 102 || type === 202 || type === 104 || type === 204) {
    return quantite + ' mois';
  }
  if (type === 103 || type === 203) {
    if (quantite === 1) {
      return quantite + ' an';
    }
    return quantite + ' ans';
  }
  return 'Non renseigné';
}

export function modeDiff(type) {
  if (type === 100 || type === 101 || type === 102 || type === 103) {
    return 'Full';
  }
  if (type === 200 || type === 201 || type === 202 || type === 203) {
    return 'Access';
  }
  return 'Non renseigné';
}

export function formatAdresse(data) {
  const adresse1 = data.adresseCommercialeLibelle1 ? data.adresseCommercialeLibelle1 : '';
  const adresse2 = data.adresseCommercialeLibelle2 ? data.adresseCommercialeLibelle2 : '';
  const adresse3 = data.adresseCommercialeLibelle3 ? data.adresseCommercialeLibelle3 : '';
  const code = data.codePostal ? data.codePostal : '';
  const ville = data.ville ? data.ville : '';
  if (adresse1 || adresse2 || adresse3 || code || ville) {
    return adresse1 + ' ' + adresse2 + ' ' + adresse3 + ' ' + code + ' ' + ville;
  }
  return '';
}

export function formatNum(tarif) {
  if (tarif) {
    return Number.parseFloat(tarif).toFixed(2) + ' €';
  }
  return Number.parseFloat(0).toFixed(2) + ' €';
}

export function formatJour(jour) {
  return jrSem[jour];
}

export function formatEclaire(data) {
  return (data ? 'Oui' : 'Non');
}

export function menuTab(keys, values) {
  const m = [];
  for (let i = 0; i < keys.length; i += 1) {
    m.push({ key: keys[i], value: values[i] });
  }
  return m.filter(el => el.value);
}
export function calPeriode(jour, semaine, annee) {
  const depart = moment(jour + 1 + '-' + semaine + '-' + annee, 'e-ww-YYYY').locale('fr').format('dddd Do MMMM YYYY');
  const fin = moment(jour + 1 + '-' + semaine + '-' + annee, 'e-ww-YYYY').add(1, 'weeks').locale('fr').format('dddd Do MMMM YYYY');
  return 'Semaine ' + semaine + ': du ' + depart + ' au ' + fin;
}
export function urlPhoto(url) {
  if (url) {
    const urlPhoto = url.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    return urlPhoto;
  }
  return require('../../assets/img/default_img.png'); // eslint-disable-line global-require
}



// WEBPACK FOOTER //
// ./src/services/opportunite/formatTab.js